import { FooterLight as FooterLightComponent } from "components/Footer/FooterLight";
import { SliceComponentProps } from "gatsby";
import React from "react";
import SliceProviders from "./SliceProviders";
import { FooterSliceContext } from "./types";

const FooterLight: React.FC<
  SliceComponentProps<unknown, FooterSliceContext>
> = ({ sliceContext }) => {
  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <FooterLightComponent urls={sliceContext.urls} />
    </SliceProviders>
  );
};

export default FooterLight;
